import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Home/AppHome.css";
import "../Admin/Admin.css";
import Headers from "./Headers";
import { useNavigate } from "react-router-dom";

function DueMembers() {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    dueDate: "",
    memberId: "",
      branchCode: "",
    phone: ""
  });

  const navigate = useNavigate();

   useEffect(() => {
          const role = sessionStorage.getItem("userRole");
          if (!role) navigate("/");
        }, [navigate]);

  useEffect(() => {
    fetchMembers();
  }, []);

const fetchMembers = async () => {
  try {
    setLoading(true);

    const res = await axios.get(
      "https://gym-invoice-back.onrender.com/api/members/due-attendance"
    );

    console.log("Due Members API:", res.data);
    console.log("First member:", res.data[0]);
    console.log("Branch codes:", res.data.map(m => m.branchCode));

    setMembers(res.data);
    setFilteredMembers(res.data);
  } catch (error) {
    console.error("Error loading data:", error);
  } finally {
    setLoading(false);
  }
};

// Place this helper function somewhere at the top of your component file
const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);

  // Convert to local timezone to avoid +1 day issue
  const localDate = new Date(d.getTime() + d.getTimezoneOffset() * 60000);

  const dd = String(localDate.getDate()).padStart(2, "0");
  const mm = String(localDate.getMonth() + 1).padStart(2, "0");
  const yyyy = localDate.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};



  const handleFilter = () => {
    let results = [...members];
    const { dueDate, memberId, phone } = filters;

    if (dueDate) {
      const selectedDate = new Date(dueDate);
      results = results.filter(
        (m) => new Date(m.nextDueDate) <= selectedDate
      );
    }
    if (memberId) {
      results = results.filter((m) =>
        m.memberId.toLowerCase().includes(memberId.toLowerCase())
      );
    }
    if (filters.branchCode) {
      results = results.filter(
        (m) =>
          (m.branchCode || "").toLowerCase() ===
          filters.branchCode.toLowerCase()
      );
    }
    if (phone) {
      results = results.filter((m) =>
        (m.phone || "").includes(phone)
      );
    }

    setFilteredMembers(results);
  };

  const clearFilters = () => {
    setFilters({ dueDate: "", memberId: "", phone: "",  branchCode: ""});
    setFilteredMembers(members);
  };

  const sendWhatsApp = (member) => {
    const message = `*📢 LIFE FITNESS PARTNER – Membership Renewal Notice*\n\n` +
      `Dear *${member.name}*,\n\n` +
      `We hope you are doing well 😊.\n\n` +
      `This is a friendly reminder that your gym membership monthly renewal has *expired*.\n\n` +
      `📌 *Member ID:* ${member.memberId}\n` +
      `📌 *Last Payment Date:* ${formatDate(member.lastPaymentDate)}\n\n` +
      `Kindly make the payment at your convenience to continue enjoying our gym facilities without interruption.\n\n` +
      `Thank you for being a valued member! 💪🙂\n\n` +
      `*📞 Need Help?*\n` +
      `Contact us: +94-761330825`;

    const phone = member.mobile || "";
    const url = `https://wa.me/94${phone.substring(1)}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };


  return (
    <div className="dashboard">
      {/* Header */}

            <Headers />

      <div className="payment-container">
        <h2>📋 Due Payments & Due Date</h2>

        {/* Filters */}
        <div className="payment-card">

        <div className="filter-item">
          <label>Branch Code</label>
          <select
            className="duration-select"
            value={filters.branchCode}
            onChange={(e) =>
              setFilters({
                ...filters,
                branchCode: e.target.value
              })
            }
          >
            <option value="">ALL BRANCHES</option>
            <option value="KB">KB - Kesbewa</option>
            <option value="WB">WB - Werahera</option>
          </select>
        </div>

        <label>Select Date</label>
          <input
            type="date"
            placeholder="Search By Date"
            value={filters.dueDate}
            onChange={(e) =>
              setFilters({ ...filters, dueDate: e.target.value })
            }
          />

          <input
            type="text"
            placeholder="Member ID"
            value={filters.memberId}
            onChange={(e) =>
              setFilters({ ...filters, memberId: e.target.value })
            }
          />


          <div className="filter-buttons">
            <button className="btn btn-primary" onClick={handleFilter}>
              Filter
            </button>
            <button className="btn btn-secondary" onClick={clearFilters}>
              Clear
            </button>
          </div>

        </div>

        {/* Table */}
        {loading ? (
          <p>Loading...</p>
        ) : filteredMembers.length === 0 ? (
          <p style={{ color: "green" }}>✅ No records found</p>
        ) : (
          <table className="payment-table">
            <thead>
              <tr>
              <th>Branch Code</th>
                <th>Member ID</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Joined</th>
                <th>Membership Type</th>
                <th>Last Payment Date</th>
                <th>Due Date</th>
                <th>Late Attendance Days</th>
                <th>Actions</th>

              </tr>
            </thead>
            <tbody>
              {filteredMembers.map((m, i) => (
                <tr key={i}>
                <td>{m.branchCode}</td>
                  <td>{m.memberId}</td>
                  <td>{m.name}</td>
                  <td>{m.mobile}</td>
                  <td>{formatDate(m.joinedDate)}</td> {/* ✅ Apply formatDate */}
                  <td>{m.membershipType}</td>
                  <td>{formatDate(m.lastPaymentDate)}</td>
                  <td style={{ color: "red", fontWeight: "bold" }}>
                    {formatDate(m.nextDueDate)}
                  </td>
                  <td style={{ color: "blue", fontWeight: "bold" }}>
                    {m.attendanceAfterDueCount || 0}
                  </td>
                  <td>
                    <button
                      className="pay-button"
                      onClick={() => sendWhatsApp(m)}
                    >
                      📲  WhatsApp
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        )}
      </div>
    </div>
  );
}

export default DueMembers;
